import { useEffect } from "react"

const useGtm = (dataLayer) => {
  useEffect(() => {
    // Add data layer to Google Tag Manager
    window.gtmDataLayer = window.gtmDataLayer || []
    window.dataLayer = window.dataLayer || window.gtmDataLayer
    window.gtmDataLayer.push(dataLayer)
  }, [dataLayer])
}

export default useGtm
